import AddDataObjectTool from "./AddDataObjectTool";
import AddCommentTool from "./AddCommentTool";
import CompareSchemaDataSetsTool from "./CompareSchemaDataSetsTool";
import FindDataObjectsTool from "./FindDataObjectsTool";
import FindErroredDataObjectsTool from "./FindErroredDataObjectsTool";
import FindSimilarDataObjectsTool from "./FindSimilarDataObjectsTool";
import GetDataObjectHistoryTool from "./GetDataObjectHistoryTool";
import MapDataObjectsCsvTool from "./MapDataObjectsCsvTool";
import ResolvePicklistContextTool from "./ResolvePicklistContextTool";
import UpdateDataObjectTool from "./UpdateDataObjectTool";
import UpdateDataSetTool from "./UpdateDataSetTool";
import UpdateDataSetRatingTool from "./UpdateDataSetRatingTool";
import UpdateDataSetTagsTool from "./UpdateDataSetTagsTool";
import type { ToolHelpers, ToolPartState } from "./types";

interface ToolPartLike {
    type: string;
    toolCallId: string;
    state: ToolPartState;
    input?: any;
    output?: any;
    errorText?: string;
}

export function renderToolPart(part: ToolPartLike, helpers: ToolHelpers) {
    const common = {
        toolCallId: part.toolCallId,
        state: part.state,
        input: part.input,
        output: part.output,
        errorText: part.errorText,
        helpers,
    };
    switch (part.type) {
        case "tool-updateDataSet":
            return <UpdateDataSetTool {...common} />;
        case "tool-updateDataSetRating":
            return <UpdateDataSetRatingTool {...common} />;
        case "tool-updateDataSetTags":
            return <UpdateDataSetTagsTool {...common} />;
        case "tool-findDataObjects":
            return <FindDataObjectsTool {...common} />;
        case "tool-findErroredDataObjects":
            return <FindErroredDataObjectsTool {...common} />;
        case "tool-findSimilarDataObjects":
            return <FindSimilarDataObjectsTool {...common} />;
        case "tool-addDataObject":
            return <AddDataObjectTool {...common} />;
        case "tool-updateDataObject":
            return <UpdateDataObjectTool {...common} />;
        case "tool-mapDataObjectsCsv":
            return <MapDataObjectsCsvTool {...common} />;
        case "tool-addComment":
            return <AddCommentTool {...common} />;
        case "tool-getDataObjectHistory":
            return <GetDataObjectHistoryTool {...common} />;
        case "tool-resolvePicklistContext":
            return <ResolvePicklistContextTool {...common} />;
        case "tool-compareSchemaDataSets":
            return <CompareSchemaDataSetsTool {...common} />;
        default:
            return null;
    }
}

export const KNOWN_TOOL_PART_TYPES = new Set<string>([
    "tool-updateDataSet",
    "tool-updateDataSetRating",
    "tool-updateDataSetTags",
    "tool-findDataObjects",
    "tool-findErroredDataObjects",
    "tool-findSimilarDataObjects",
    "tool-addDataObject",
    "tool-updateDataObject",
    "tool-mapDataObjectsCsv",
    "tool-addComment",
    "tool-getDataObjectHistory",
    "tool-resolvePicklistContext",
    "tool-compareSchemaDataSets",
]);
